import { TextField } from "@mui/material"
import InputAdornment from '@mui/material/InputAdornment';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import React from "react"

const DateInputShowComponent = React.forwardRef(({ id, placeholder, onClick, width = "200px" }, ref) => {
  const onClickHandler = event => {
    onClick && onClick(event)
  }
  return (
    <TextField
      id={id}
      value={placeholder}
      onClick={e => onClickHandler(e)}
      variant="outlined"
      sx={{ mt: 1, width, height: "20px", marginTop: "0px" }}
      size="small"
      InputProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <CalendarMonthIcon />
            </InputAdornment>
          ),
        },
      }}
      
    />
  )
})

export default DateInputShowComponent
